<template>
  <div class="m-confirmation">
    <b-modal
      id="confirm-modal"
      v-model="active"
      size="custom-size"
      centered
      hide-footer
      :title="texts.title"
      :no-close-on-esc="!!modal"
      :no-close-on-backdrop="!!modal"
      :hide-header-close="!!modal"
      @close="active = false"
    >
      <div class="m-confirmation-text">
        <span v-if="texts.text" v-html="texts.text"></span>
        <slot></slot>
      </div>
      <div class="m-confirmation-buttons">
        <c-button size="large" :label="texts.reset || 'Отменить'" :disabled="busy" @click="close" />

        <c-button size="large" :label="texts.confirm || 'Подтвердить'" :color="confirmColor" :disabled="busy" @click="onConfirm" />
      </div>
    </b-modal>
  </div>
</template>
<script>
import Button from "@/components/controls/button";

export default {
  name: "confirm-modal",

  components: {
    "c-button": Button,
  },

  props: ["title", "text", "confirm", "reset", "mode", "modal"],

  data() {
    return {
      busy: false,
      active: false,
      texts: {
        title: "",
        text: "",
        confirm: "",
        reset: "",
      },
      buttonMode: "danger",
      cb: null,
    };
  },

  computed: {
    confirmColor() {
      if (this.buttonMode === "danger") return "pink";
      if (this.buttonMode === "primary") return "blue";
      return null;
    }
  },

  created() {
    this.texts.title = this.title;
    this.texts.text = this.text;
    this.texts.confirm = this.confirm;
    this.texts.reset = this.reset;
    this.buttonMode = this.mode;
  },

  methods: {
    open(params = {}) {
      if ("title" in params) {
        this.texts.title = params.title;
      }

      if ("text" in params) {
        this.texts.text = params.text;
      }

      if ("confirm" in params) {
        this.texts.confirm = params.confirm;
      }

      if ("reset" in params) {
        this.texts.reset = params.reset;
      }

      this.buttonMode = params.mode || this.mode;

      this.cb = params.onConfirm;

      this.active = true;
    },

    close() {
      this.active = false;
      this.$emit("close");
    },

    async onConfirm() {
      if (typeof this.cb === "function") {
        this.busy = true;

        await this.cb();

        this.busy = false;
      }
      this.$emit("confirm");
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.m-confirmation {
  position: absolute;
  width: 100%;
  transition: 0.2s;

  @media (max-width: 700px) {
    &-title {
      font-size: 15px;
    }
  }

  &-text {
    font: 400 15px Fira Sans;
    overflow: hidden;
    line-height: 120%;
    overflow: hidden;
    overflow-wrap: anywhere;
  }
  @media (max-width: 700px) {
    &-text {
      font-size: 13px;
    }
  }

  &-close {
    position: absolute;
    top: 12px;
    right: 10px;
    cursor: pointer;
  }

  &-input {
    margin-top: 23px;
  }

  &-buttons {
    display: flex;
    margin-top: 25px;
    justify-content: flex-end;

    &::v-deep > .c-button:first-child {
      margin-right: 10px;
    }
    @media (max-width: 700px) {
      &::v-deep > .c-button {
        margin-right: 0 !important;
        width: 50%;
      }

      &::v-deep > .c-button > .c-button__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0 !important;
        border-radius: 0;
      }
    }
  }
  @media (max-width: 700px) {
    &-buttons {
      margin: 30px -20px 0 -20px;
    }
  }
}

::v-deep .modal-custom-size {
  max-width: 590px !important;
}
::v-deep .modal-body {
  padding: 20px 34px 30px 32px;
}
@media (max-width: 700px) {
  ::v-deep .modal-dialog-centered {
    align-items: flex-start;
  }
  ::v-deep .modal-custom-size {
    max-width: 100% !important;
  }
  ::v-deep .modal-body {
    padding: 16px 20px 0 20px;
  }
  ::v-deep .modal-content {
    height: auto;
  }
}
::v-deep .modal-dialog {
  margin: 0 auto;
}
::v-deep .modal.fade .modal-dialog {
  transform: none;
}


</style>
